export enum Subpages {
  REFERRAL_REPORT = 'referral-reports',
  PIPELINE = 'pipeline',
  DASHBOARD = 'dashboard',
}
